import type { TUser } from '@models/authorization/TUser';

export function isBillingUser(user: Pick<TUser, 'roles'>): boolean {
  return user.roles.some((role) => role.roleKey?.startsWith('billing') ?? false);
}
